import {useEffect} from "react";
import {DndProvider} from "react-dnd";
import {Provider, useSelector} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {HTML5Backend} from "react-dnd-html5-backend";
import {useRoutes, useNavigate, useLocation} from "react-router-dom";
import store, {persistor} from './store';
import navigation from "./navigation";
import AuthController from './controllers/AuthController';
import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import theme from "./theme";
import {Loader} from "./components/Loader";
import {AlertProvider} from "./components/AlertNotification";
import { ActionProvider } from "./context/actionContext";

const AppContent = () => {
    const content = useRoutes(navigation);
    const navigate = useNavigate();
    const accessToken = useSelector(state => state.auth.accessToken);

    useEffect(() => {
        if (window.location.pathname.includes('app') && !accessToken) {
            navigate('/login', {replace: true});
        }
    }, [accessToken, navigate]);

    return (
        <ActionProvider>
            <ThemeProvider theme={theme}>
                <DndProvider backend={HTML5Backend}>
                    <AuthController>
                        <AlertProvider>
                            {content}
                        </AlertProvider>
                    </AuthController>
                </DndProvider>
            </ThemeProvider>
        </ActionProvider>
    );
}

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AppContent />
            </PersistGate>
        </Provider>
    );
}

export default App;
